import React from 'react';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import { useAdminBackofficePage } from './hook';

const AdminBackofficePage = () => {
  const { sections } = useAdminBackofficePage();

  return (
    <PageContainer withPaddingTop={0} title="Super Admin Backoffice">
      <Sidebar sections={sections} headerLabel="Super Admin" />
    </PageContainer>
  );
};

export default AdminBackofficePage;
